import React, { useState } from 'react';
import TeacherSelect from './TeacherSelect';
import GroupSelect from './GroupSelect';

function ScheduleFilters({ activeTab, groups, teachers, onLoadSchedule, loading }) {
  // Устанавливаем начальные даты: сегодня и через неделю
  const getInitialDates = () => {
    const today = new Date();
    const weekLater = new Date(today);
    weekLater.setDate(today.getDate() + 7);
    
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    return {
      from: formatDate(today),
      to: formatDate(weekLater)
    };
  };

  const initialDates = getInitialDates();
  const [groupGuid, setGroupGuid] = useState('');
  const [teacherGuid, setTeacherGuid] = useState('');
  const [dateFrom, setDateFrom] = useState(initialDates.from);
  const [dateTo, setDateTo] = useState(initialDates.to);
  const [dateError, setDateError] = useState('');

  // Вычисляем минимальную дату (неделя назад от сегодня)
  const getMinDate = () => {
    const today = new Date();
    const weekAgo = new Date(today);
    weekAgo.setDate(today.getDate() - 7);
    
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    return formatDate(weekAgo);
  };

  const minDate = getMinDate();

  const validateDates = (from, to) => {
    if (!from || !to) {
      return '';
    }
    const fromDate = new Date(from);
    const toDate = new Date(to);
    
    if (fromDate > toDate) {
      return 'Дата начала не может быть позже даты окончания';
    }
    return '';
  };

  const handleDateFromChange = (e) => {
    const newDateFrom = e.target.value;
    setDateFrom(newDateFrom);
    const error = validateDates(newDateFrom, dateTo);
    setDateError(error);
  };

  const handleDateToChange = (e) => {
    const newDateTo = e.target.value;
    setDateTo(newDateTo);
    const error = validateDates(dateFrom, newDateTo);
    setDateError(error);
  };

  const handleLoad = () => {
    if (!dateFrom || !dateTo) {
      alert('Пожалуйста, заполните все поля');
      return;
    }

    const error = validateDates(dateFrom, dateTo);
    if (error) {
      alert(error);
      return;
    }

    if (activeTab === 'students') {
      if (!groupGuid) {
        alert('Пожалуйста, выберите группу');
        return;
      }
      onLoadSchedule('group', { guid: groupGuid, dateFrom, dateTo });
    } else if (activeTab === 'teachers') {
      if (!teacherGuid) {
        alert('Пожалуйста, выберите преподавателя');
        return;
      }
      onLoadSchedule('teacher', { guid: teacherGuid, dateFrom, dateTo });
    } else {
      onLoadSchedule('auditorium', { guid: '', dateFrom, dateTo });
    }
  };

  return (
    <div className="filters-container">
      {/* Фильтры для студентов */}
      {activeTab === 'students' && (
        <div className="filter-section active">
          <div className="filter-row">
            <label>Группа:</label>
            <div className="search-wrapper">
              <GroupSelect
                groups={groups}
                value={groupGuid}
                onChange={setGroupGuid}
              />
            </div>
          </div>
          <div className="filter-row">
            <label>С:</label>
            <input
              type="date"
              value={dateFrom}
              onChange={handleDateFromChange}
              min={minDate}
              max={dateTo}
            />
          </div>
          <div className="filter-row">
            <label>По:</label>
            <input
              type="date"
              value={dateTo}
              onChange={handleDateToChange}
              min={dateFrom}
            />
          </div>
          {dateError && (
            <div className="date-error" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
              {dateError}
            </div>
          )}
          <button
            className="load-button"
            onClick={handleLoad}
            disabled={loading || !!dateError}
          >
            {loading ? 'Загрузка...' : 'Загрузить расписание'}
          </button>
        </div>
      )}

      {/* Фильтры для преподавателей */}
      {activeTab === 'teachers' && (
        <div className="filter-section active">
          <div className="filter-row">
            <label>Преподаватель:</label>
            <div className="search-wrapper">
              <TeacherSelect
                teachers={teachers}
                value={teacherGuid}
                onChange={setTeacherGuid}
              />
            </div>
          </div>
          <div className="filter-row">
            <label>С:</label>
            <input
              type="date"
              value={dateFrom}
              onChange={handleDateFromChange}
              min={minDate}
              max={dateTo}
              className={dateError ? 'input-error' : ''}
            />
          </div>
          <div className="filter-row">
            <label>По:</label>
            <input
              type="date"
              value={dateTo}
              onChange={handleDateToChange}
              min={dateFrom}
              className={dateError ? 'input-error' : ''}
            />
          </div>
          {dateError && (
            <div className="date-error" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
              {dateError}
            </div>
          )}
          <button
            className="load-button"
            onClick={handleLoad}
            disabled={loading || !!dateError}
          >
            {loading ? 'Загрузка...' : 'Загрузить расписание'}
          </button>
        </div>
      )}

      {/* Фильтры для аудитории */}
      {activeTab === 'auditorium' && (
        <div className="filter-section active">
          <div className="filter-row">
            <label>Аудитория:</label>
            <div className="select-wrapper">
              <select>
                <option value="">Выберите аудиторию</option>
              </select>
            </div>
          </div>
          <div className="filter-row">
            <label>С:</label>
            <input
              type="date"
              value={dateFrom}
              onChange={handleDateFromChange}
              min={minDate}
              max={dateTo}
              className={dateError ? 'input-error' : ''}
            />
          </div>
          <div className="filter-row">
            <label>По:</label>
            <input
              type="date"
              value={dateTo}
              onChange={handleDateToChange}
              min={dateFrom}
              className={dateError ? 'input-error' : ''}
            />
          </div>
          {dateError && (
            <div className="date-error" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
              {dateError}
            </div>
          )}
          <button
            className="load-button"
            onClick={handleLoad}
            disabled={loading || !!dateError}
          >
            {loading ? 'Загрузка...' : 'Загрузить расписание'}
          </button>
        </div>
      )}
    </div>
  );
}

export default ScheduleFilters;


